const services = [
  {
    icon: 'ri-pencil-ruler-2-line',
    title: 'Custom Design',
    description: 'Have an idea but no file? We design it from scratch. Send us a sketch, a photo, or just a description — we\'ll turn it into a print-ready 3D model.',
    gradient: 'from-fuchsia-500 to-pink-500',
    image: 'https://public.readdy.ai/ai/img_res/400be17f842b48e59aa46165fa82d6ed.jpg',
  },
  {
    icon: 'ri-tools-line',
    title: 'Rapid Prototyping',
    description: 'Engineers, inventors, and entrepreneurs — get your prototype fast. We print functional parts with tight tolerances so you can test and iterate quickly.',
    gradient: 'from-orange-400 to-yellow-400',
    image: 'https://readdy.ai/api/search-image?query=3D%20printed%20prototype%20mechanical%20part%20on%20white%20surface%2C%20engineering%20prototype%20with%20visible%20layer%20lines%2C%20technical%20precision%20manufacturing%2C%20clean%20minimal%20background%2C%20warm%20studio%20lighting&width=600&height=400&seq=service-proto-001&orientation=landscape',
  },
  {
    icon: 'ri-palette-line',
    title: 'Custom Art Pieces',
    description: 'Sculptures, figurines, wall art, and one-of-a-kind decorative pieces. We print your vision in vivid detail with premium multi-color filaments.',
    gradient: 'from-cyan-400 to-teal-500',
    image: 'https://readdy.ai/api/search-image?query=colorful%203D%20printed%20art%20sculpture%20on%20display%2C%20vibrant%20rainbow%20colored%20decorative%20figurine%2C%20artistic%203D%20print%20with%20intricate%20details%2C%20gallery%20display%2C%20dramatic%20lighting%20on%20dark%20background&width=600&height=400&seq=service-art-001&orientation=landscape',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Functional Parts',
    description: 'Need a replacement part or a custom bracket? We print durable, functional components in a variety of materials suited for real-world use.',
    gradient: 'from-violet-500 to-fuchsia-500',
    image: 'https://readdy.ai/api/search-image?query=3D%20printed%20functional%20mechanical%20parts%20and%20components%2C%20gears%20brackets%20connectors%20in%20grey%20and%20black%20PLA%20material%2C%20industrial%20precision%20parts%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=600&height=400&seq=service-parts-001&orientation=landscape',
  },
  {
    icon: 'ri-gamepad-line',
    title: 'Miniatures & Collectibles',
    description: 'Tabletop gaming pieces, character models, collectible figurines — printed with incredible detail at any scale you need.',
    gradient: 'from-emerald-400 to-cyan-500',
    image: 'https://readdy.ai/api/search-image?query=detailed%203D%20printed%20miniature%20figurines%20for%20tabletop%20gaming%2C%20tiny%20painted%20fantasy%20characters%20on%20wooden%20surface%2C%20intricate%20small%20scale%20models%2C%20dramatic%20macro%20photography%2C%20dark%20moody%20background&width=600&height=400&seq=service-mini-001&orientation=landscape',
  },
  {
    icon: 'ri-gift-line',
    title: 'Personalized Gifts',
    description: 'Make someone\'s day unforgettable. Custom name plates, keychains, photo frames, and personalized keepsakes — printed just for them.',
    gradient: 'from-rose-400 to-orange-400',
    image: 'https://readdy.ai/api/search-image?query=personalized%203D%20printed%20gift%20items%2C%20custom%20name%20plate%20keychain%20and%20decorative%20piece%2C%20colorful%20vibrant%20filament%2C%20gift%20wrapping%20presentation%2C%20warm%20cozy%20background%2C%20lifestyle%20photography&width=600&height=400&seq=service-gift-001&orientation=landscape',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 px-6 md:px-10 bg-[#fafafa]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <div>
            <span className="text-xs uppercase tracking-[3px] font-bold bg-gradient-to-r from-fuchsia-500 to-orange-400 bg-clip-text text-transparent">
              What We Do
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mt-3 leading-tight">
              What We Create
            </h2>
          </div>
          <p className="text-gray-500 text-base leading-relaxed max-w-md">
            From concept to physical reality — our 3D printing services cover everything you need to bring your ideas into the world.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-1 transition-transform duration-300"
              style={{ border: '1px solid #f0f0f0' }}
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.gradient} mb-4`}>
                  <i className={`${service.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
